import React from 'react';

import clsx from 'clsx';

import Button from 'components/Button';
import Card from 'components/Card';
import Grid from 'components/Grid';
import Typography from 'components/Typography';
import { useAppContext } from 'context/AppContext';
import { useEventContext } from 'context/EventContext';
import useViewport from 'hooks/useViewport';
import useLasForm from 'screens/serp/hooks/useLasForm';

import firstImg from './assets/first.png';
import lastImg from './assets/last.png';
import middleImg from './assets/middle.png';

import classes from './PPLBanner.module.scss';

/** @type {import("./types").default} */
const PPLBanner = ({ className, category, ...props }) => {
  const { addEvent } = useEventContext();
  const { head } = useAppContext();
  const { up, is } = useViewport();
  const isDesktop = up('md');
  let headDataLayer = head?.data_layer;

  // NOTE: necessary to prevent 404
  if (typeof headDataLayer !== 'undefined') {
    headDataLayer = head?.data_layer[0];
  }
  const globalCategoryId = headDataLayer?.categoryPageUuid;

  const callfunc = useLasForm({
    hasPplExitIntentEnabled: true,
    global_category_id: globalCategoryId,
    isPPL: true,
    config: { formTemplate: 'faststart' },
    form: 'openLasModal',
    hasCallFunction: true,
  });

  return (
    <Grid className={clsx('PPLBanner', classes.root, className)} {...props}>
      <Card
        className={classes.cardGradient}
        elevation={1}
        onClick={() => {
          !isDesktop && callfunc();
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={3} md={12} className={classes.usersContainer}>
            <img
              src={firstImg.src}
              alt="users"
              onClick={() => {
                isDesktop && callfunc();
              }}
            />
            <img
              src={middleImg.src}
              alt="users"
              onClick={() => {
                isDesktop && callfunc();
              }}
            />
            <img
              src={lastImg.src}
              alt="users"
              onClick={() => {
                isDesktop && callfunc();
              }}
            />
          </Grid>

          <Grid item xs={12} sm={9} md={12}>
            <Typography variant="h3" className={classes.title}>
              Talk with us for a free 15-min consultation
            </Typography>
            {up('sm') && (
              <Typography className={classes.subTitle}>
                Expert advisors like Chase, who have helped 1,000+ companies,
                can find the right {category} software for your needs.
              </Typography>
            )}

            {!is('sm') && (
              <Button
                fullWidth
                size="small"
                variant="outlined"
                onClick={() => {
                  callfunc();
                }}
                {...addEvent({
                  engagementComponent: 'ppl_banner',
                  engagementDestination: 'banner_displayed',
                  engagementDetails: 'ppl_banner',
                  name: 'ppl_cta',
                })}
              >
                TALK TO AN EXPERT
              </Button>
            )}
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};
export default PPLBanner;
